import { FETCH_SHIPPING_LIST } from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {},
};

const shippingListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SHIPPING_LIST:
      return { list: action.payload, others: action.others };
    default:
      return state;
  }
};

export default shippingListReducer;
